export function isMoopsyError(input) {
    return ("_isMoopsyError" in input && input._isMoopsyError === true) || "_isSeamlessError" in input;
}
